// extracted by mini-css-extract-plugin
module.exports = {"title__main":"pageTitle_title__main__3Ms97"};